/* Momeaze — product card "add to cart" button.
   Delegated so it also covers cards injected later by facet filtering,
   pagination and quick-add re-renders. */
(function () {
  'use strict';
  if (window.MzCardActions) return;

  function drawer() {
    return document.querySelector('cart-drawer');
  }

  function bumpBubble(delta) {
    var el = document.querySelector('.cart-count-bubble span[aria-hidden]');
    if (el) el.textContent = String((parseInt(el.textContent, 10) || 0) + delta);
  }

  function flash(message) {
    var t = document.querySelector('.mz-card-toast');
    if (t) t.remove();
    t = document.createElement('div');
    t.className = 'mz-card-toast';
    t.textContent = message;
    document.body.appendChild(t);
    requestAnimationFrame(function () {
      t.classList.add('show');
    });
    setTimeout(function () {
      t.classList.remove('show');
      setTimeout(function () {
        t.remove();
      }, 300);
    }, 2600);
  }

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function sectionConfig(cd) {
    if (cd && typeof cd.getSectionsToRender === 'function') {
      return cd.getSectionsToRender();
    }
    return [
      { id: 'cart-drawer', selector: '#CartDrawer' },
      { id: 'cart-icon-bubble' },
    ];
  }

  // Fresh sections from the root URL, so the search / collection page
  // context can't affect what the drawer renders.
  function fetchSections(ids) {
    return fetch(root + '?sections=' + encodeURIComponent(ids.join(',')) + '&t=' + Date.now(), {
      headers: { Accept: 'application/json' },
    }).then(function (r) {
      if (!r.ok) throw new Error('sections fetch failed');
      return r.json();
    });
  }

 function manualRender(cd, config, sections) {
  config.forEach(function (s) {
    var target = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
    var html = sections[s.id];
    if (!target || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var src = s.selector ? doc.querySelector(s.selector) : doc.querySelector('.shopify-section');
    if (src) target.innerHTML = src.innerHTML;
  });
  if (cd) {
    cd.classList.remove('is-empty');
    if (typeof cd.open === 'function') cd.open();
  }
}

function renderDrawer(variantId) {
  var cd = drawer();
  var config = sectionConfig(cd);
  var ids = config.map(function (s) { return s.id; });

  return fetchSections(ids).then(function (sections) {
    // Host se is-empty hatana zaruri hai, warna open() trapFocus(null) pe crash hota hai
    if (cd) cd.classList.remove('is-empty');

    var state = { id: variantId, key: String(variantId), sections: sections };
    if (cd && typeof cd.renderContents === 'function') {
      try {
        cd.renderContents(state);
        return;
      } catch (err) {
        console.warn('[MzCardActions] renderContents failed, using fallback', err);
      }
    }
    manualRender(cd, config, sections);
  });
}

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.mz-card-cart');
    if (!btn) return;

    // Stop the click from reaching Dawn's full-card title-link overlay.
    e.preventDefault();
    e.stopPropagation();

    var variantId = parseInt(btn.dataset.variant, 10);
    if (!variantId || btn.disabled) return;

    var cd = drawer();
    if (cd && typeof cd.setActiveElement === 'function') cd.setActiveElement(btn);

    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then(function (r) {
        return r.json().then(function (data) {
          return { ok: r.ok, data: data };
        });
      })
      .then(function (res) {
        if (!res.ok) {
          // 422 = sold out / exceeds stock.
          flash(res.data.description || res.data.message || 'Could not add to cart');
          return;
        }
        return renderDrawer(variantId).catch(function (err) {
          console.error('[MzCardActions] drawer render failed', err);
          bumpBubble(1);
          flash('Added to cart');
        });
      })
      .catch(function () {
        flash('Could not add to cart');
      })
      .finally(function () {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      });
  });

  window.MzCardActions = true;
})();